<template>
  <ion-page>
    <master-layout pageTitle="افزودن ضایعات">
      <ion-card>
        <ion-card-content>
          <div >
            <AjaxForm route="AutoWastage/Add" :callback="addCallback" >
              <div>
                <label>عنوان</label>
                <input type="text" name="title" class="form-control">
              </div>
              <div>
                <label>مقدار</label>
                <input type="text" name="amount" class="form-control">
              </div>
              <div>
                <label>واحد</label>
                <input type="text" name="unit" class="form-control">
              </div>
              <ion-button color="success" type="submit" expand="full">افزودن</ion-button>
            </AjaxForm>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {IonPage} from '@ionic/vue';
import {showSystemNoti} from "@/shared/helper";
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  components: {
    IonPage,
    AjaxForm
  },
  data()
  {
    return {
      id : null,
    }
  },
  async created()
  {

  },
  methods: {
    addCallback(result){
      const self = this;
      if (!result.ok){
        showSystemNoti('danger',result.error);
      }
      else
        showSystemNoti('success',result.message,function ()
        {
          self.$router.push({path: '/wastage/List'});
        });
    }
  }
}

</script>

<style scoped>
.h6 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
</style>